import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Retirees = () => { return (
<div className="container" style={{backgroundColor: '#F7F7F7'}}>
    <Navbar />

    <div className="retirees-banner">
        <div className="text">Retirees</div>
    </div>

    <div className="sticky-anchors">
        <div className="sticky-anchors-inner">
            <a href="#know-your-benefits">Know your Benefits</a>
            <a href="#benefits-center">Benefits Center</a>
            {/* <a href="#care-givers">Care Givers</a> */}
        </div>
    </div>
    <div className="anchor-containers text_regular_grey">
        <div className="know-your-benefits" id="know-your-benefits">
            <div className="left">
                <div className="big-title">Know your benefits</div>
                <div className="sub-title" style={{ fontSize: 24 }}>Pfizer remains committed to supporting the health of you and your covered dependents through the Pfizer Retiree Medical Plan. For information about your Pfizer benefits, contact the Pfizer Benefits Center either:</div>

                <div className="line-separator"></div>

                <div className="online">
                    <div className="content">Online</div>
                    <a href="https://netbenefits.com" className="title" target="_blank" style={{textDecoration: 'underline'}}>netbenefits.com</a>
                </div>

                <div className="line-separator"></div>

                <div className="phone">
                    <div className="content">Phone</div>
                    <div className="title">1-877-208-0950</div>
                    <div className="content" style={{marginTop: 10}}>Benefits representatives are available to assist you Monday through Friday from 8:30 a.m. to midnight, Eastern time.</div>
                </div>
            </div>
            <div className="right-top">
                <div className="title">Important Reminder</div>
                <div className="label">Make Sure Your Dependents Meet Pfizer's Eligibility Requirements</div><br/>
                <div className="content">When you enroll or make changes to your enrollment, you will be required to confirm that your dependents meet Pfizer's eligibility requirements. Pfizer regularly verifies dependents covered under the Pfizer Retiree Medical Plan, and you may be asked to provide proof of eligibility. It is your responsibility to report any changes in your dependent's status, such as a divorce. Changes must be reported within 31 days of the event to the Pfizer Benefits Center.</div>
            </div>
            <div className="right-bottom" style={{ fontFamily: "'Pfizer Diatype Office', sans-serif"}}>
                <div className="title">Support for Caregivers Assisting with Enrollment</div><br/>
                <div className="content">If you have a caregiver that helps with your enrollment elections or navigating your health care, a power of attorney may be required in order for your caregiver to speak with Fidelity at the Pfizer Benefits Center. For your security, Fidelity at the Pfizer Benefits Center requires their own documentation, even if you have a power of attorney on file with the medical plan administrator (e.g., Horizon or UHC). Additionally, if there are questions about your health coverage or a claim, Fidelity may also require you to complete a HIPAA authorization form. Contact Fidelity at the Pfizer Benefit Center at 1-877-208-0950.
                </div>
            </div>
        </div>

        <div className="benefits-center" id="benefits-center">
            <div className="container-1">
                <div className="d1">
                    <div className="big-title">Benefits Center</div>
                    <div className="title">Keep Your Information Up-to-date with Pfizer Benefits Center</div>
                </div>
                <div className="content">
                The Pfizer Benefits Center is your primary resource for information, transactions and services related to your retiree benefits, which include healthcare, and depending on your plan, dental, life insurance, savings, pension and stock awards. You can reach the Pfizer Benefits Center by <span>phone</span> (toll-free) or <span>online</span>. 
                <br/><br/>Be sure your personal information is correctly listed with the Pfizer Benefits Center. It's important to keep your mailing and email address up-to-date so you continue to receive information about your Pfizer benefits. If you are eligible for retiree life insurance, confirm your beneficiary data is current and accurate; and if you receive a pension benefits from Pfizer, be sure to also provide new or updated direct deposit information for your bank.
                <br/><br/>If you need to update your information, call the Pfizer Benefits Center at <span><b>1-877-208-0950</b></span>.
                </div>
            </div>

            <div className="container-2">
                <div className="d1">
                    <div className="title" style={{marginBottom: '20px'}}>Phone</div>
                    <div className="content" style={{fontSize: 24}} >To reach the Pfizer Benefits Center by phone, call 1-877-208-0950. Benefits representatives are available to assist you Monday through Friday from 8:30 a.m. to midnight, Eastern time.</div>
                </div>
            </div>

            {/* <div className="container-3 content">
                <div className="header">Task</div>
                <div className="header">What you will need to provide</div>

                <div className="line-separator"></div>
                <div className="task-1">
                    <div className="sub-tasks">
                        <div>
                            Make a change to your medical or dental coverage (if eligible), including:<br/><br/>
                            <ul>
                                <li>Changing your plan option (at annual enrollment or following a change in address)</li>
                                <li>Changing the dependents you cover</li>
                                <li>Changing your address</li>
                                <li>Making a beneficiary change on your life insurance if applicable</li>
                            </ul>
                        </div>
                        <div>Ask a question about a bill or benefits claim.</div>
                        <div>Ask a question about your savings plan or access your account.</div>
                        <div>Request a pension estimate or a distribution, or ask a question about your pension payment.</div>
                    </div>
                </div>
                <div>Social Security number or Customer ID + Fidelity PIN (6-12 digits)</div>

                <div className="line-separator"></div>
                <div className="task-2">
                    <div>Change of Address</div>
                    <div>You will need to call the Pfizer Benefits Center at 1-877-208-0950 to change your address. At the medical, dental, life insurance and billing prompt, you will be connected to a benefits specialist who will help you make this change.</div>
                </div>

                <div className="line-separator"></div>
                <div className="task-3">
                    <div style={{marginBottom: '32px'}}>Request a form, including a tax withholding, direct deposit and matching gift forms</div>
                    <div>Report a death</div>
                </div>
                <div>No PIN required</div>
            </div> */}

            {/* <div className="container-4">
                <div className="title" style={{marginBottom: '20px'}}>Interactive Voice Response (IVR) Menu</div>
                <div className="content">
                    <div className="d1">
                        When you call the Pfizer Benefits Center at 1-877-208-0950, you will be asked if you are an active colleague or presently on a leave of absence and you will need to respond "Yes or No." Respond "No."
                        <br/><br/>You will then be asked if you are a Retiree, Survivor, Alternate Payee or Former Colleague. Respond "Yes."
                        <br/><br/>You will then be directed to 6 menu options. Each option corresponds to a different type of benefit or service. You will be asked to press or say the number which corresponds to the appropriate benefit or service for which you have a question or need help.
                        <br/><br/><ul style={{paddingLeft: '18px', listStyleType: 'decimal'}}>
                            <li>For Medical, Dental, Life Insurance or Billing</li>
                            <li>For Pension</li>
                            <li>For Savings</li>
                            <li>Stock Awards</li>
                            <li>To Report a Death</li>
                            <li>For all other questions</li>
                        </ul>
                    </div>
                    <div className="d2">
                        You will need to have your Social Security Number and Fidelity PIN (6-12 digits) handy when you call the Pfizer Benefits Center (except when calling about stock options.)                    
                        <br/><br/>If you forget or lose your PIN, you can change it from the IVR menu. Just select the menu prompt for the type of benefit or inquiry (from the options above) and then follow the prompts on the voice menu to change your Fidelity PIN.
                    </div>
                </div>
            </div>

            <div className="container-5">
                <div className="title" style={{marginBottom: '20px'}}>Online</div>
                <div className="content">
                    <div className="d1">
                        Log in to the Pfizer Benefits Center online at <a href="https://netbenefits.com" style={{textDecoration: 'underline'}} target="_blank">www.netbenefits.com</a> to:<br/><br/>
                        <ul style={{paddingLeft: '25px'}}>
                            <li>Obtain information about your medical, dental (if eligible), savings plan and pension.</li>
                            <li>Locate Summary Plan Descriptions.</li>
                            <li>Find contact information for your specific plans. (Click "who to contact")</li>
                            <li>Obtain medical coverage forms such as claims forms and HIPAA authorization forms (HIPAA forms are necessary if you want to designate someone to access to your medical records).</li>
                            <li>Make beneficiary changes to your savings and pension plan.</li>
                        </ul>
                    </div>
                    <div className="d2">
                        You will need your Social Security number and Fidelity PIN (6-12 digits) to log in to the site. If you are using the Pfizer Benefits Center online for the first time, you will need to register first. If you forget your password or PIN, simply follow the prompts on the screen or call the toll-free 800 number provided online for assistance in re-setting your PIN.
                    </div>
                </div>
            </div> */}
        </div>


        {/* <div className="care-givers" id="care-givers">
            <div className="big-title">Caregivers</div>
            <div className='content'>As a caregiver of a Pfizer retiree, we understand you have unique needs. This page provides information and links to some helpful sites for caregivers.</div>

            <div>
                <div className="title">Health Care Directive (Living Will and Medical Power of Attorney)</div><br/>
                <div>If something unexpected should happen to you that left you unable to make medical decisions on your own, who would make them?
                    <br/><br/>The simplest way to ensure your wishes are carried out by those you trust is to draw up a Health Care Directive. This document serves as both a Living Will and a Medical Power of Attorney. You can talk with an estate or financial planner, if you have one, an attorney, or other trusted advisor as you consider what you want and who you would trust to make medical decisions on your behalf.
                    <br/><br/>There are also thousands of resources on the internet that can help you if you do not have an attorney or counselor, or if you would like to handle this important work yourself. For example, you can complete a Health Care Directive in a few minutes online or visit www.lawdepot.com.
                </div>
            </div>

            <div>
                <div className="title">Links to Caregiver Resources</div><br/>
                <div className="links">
                    <div className="content">If you are taking care of someone, you may find the resources below helpful.</div><br/><br/>
                    <ul className="label" style={{paddingLeft: '28px'}}>
                        <li><a href="https://www.myhealthcarefinances.com" target="_blank">MyHealthcareFinances.com</a></li>
                        <li><a href="https://pfizerplus.com/kb/resources_for_caregivers.aspx#" target="_blank">Family Caregivers Are Under Pressure, These Tools and Tips Can Help ®</a></li>
                        <li><a href="https://pfizerplus.com/kb/resources_for_caregivers.aspx#" target="_blank">Family Caregiver Alliance</a></li>
                        <li><a href="https://pfizerplus.com/kb/resources_for_caregivers.aspx#" target="_blank">Administration for Community Living</a></li>
                        <li><a href="https://pfizerplus.com/kb/resources_for_caregivers.aspx#" target="_blank">US Department of Health and Human Services</a></li>
                        <li><a href="https://pfizerplus.com/si/articles/article-a-guide-to-self-care-for-caregivers.aspx" target="_blank">Caregiver Support: A Guide to Self-Care for Caregivers</a></li>
                    </ul>
                </div>
            </div>
        </div> */}
    </div>

    <Footer />
</div>
);
};
export default Retirees;